import { render, staticRenderFns } from "./posProforma.vue?vue&type=template&id=470d666c&scoped=true&"
import script from "./posProforma.vue?vue&type=script&lang=js&"
export * from "./posProforma.vue?vue&type=script&lang=js&"
import style0 from "./posProforma.vue?vue&type=style&index=0&id=470d666c&prod&scoped=true&lang=css&"
import style1 from "./posProforma.vue?vue&type=style&index=1&id=470d666c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d666c",
  null
  
)

export default component.exports